import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import testimonial1 from '../../images/testimonial/img-1.jpg'
import testimonial2 from '../../images/testimonial/img-2.jpg'
import Quote from '../../images/testimonial/quote.svg'


const testimonials = [
    {
        id: "01",
        Des: "I was searching for a commercial plot in a prime area. The team offered multiple options & helped finalize a great deal near SG Highway. Their knowledge of property trends, documentation, & negotiation was extremely valuable & professional.",
        Title: "Rohit Shah",
        Sub: "Satellite, Ahmedabad",
        image: testimonial1,
    },
    {
        id: "02",
        Des: "We wanted a peaceful residential plot in Gandhinagar to build our dream home. The team managed everything - from site visits to legal paperwork - with full transparency. Their honest approach & coordination made the entire process stress-free.",
        Title: "Nidhi Patel",
        Sub: "Kudasan, Gandhinagar",
        image: testimonial2,
    },
    {
        id: "03",
        Des: "We were facing issues with property title clarity. Their legal support resolved all doubts and helped us find a buyer within just 20 days. They worked quickly, explained everything clearly, and guided us through a secure, hassle-free transaction.",
        Title: "Harshil Desai",
        Sub: "Chandkheda, Ahmedabad",
        image: testimonial2,
    },
    {
        id: "04",
        Des: "As a first-time buyer, I appreciated how patiently they walked me through the process. From shortlisting properties to legal agreements, they handled it all. Their detailed guidance made me feel confident and well-supported at every step.",
        Title: "Meena Joshi",
        Sub: "Sector 21, Gandhinagar",
        image: testimonial1,
    },
    {
        id: "05",
        Des: "We urgently needed an industrial space for expansion. The consultants showed us verified properties with correct zoning and managed the deal smoothly. Their backend support, documentation clarity, and quick response saved us time and effort.",
        Title: "Ankit Trivedi",
        Sub: "Bopal, Ahmedabad",
        image: testimonial2,
    },
];


const Testimonial = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    arrows: false,
                }
            },
        ]
    }


    return (
        <section className={"" + props.hclass}>
            <Slider {...settings} className="testimonial-slider">
                {testimonials.slice(0, 5).map((testimonial, item) => (
                    <div className="item" key={item}>
                        <div className="bg-image">
                            <img src={testimonial.image} alt="testimonial" />
                        </div>
                        <div className="content fade_bottom">
                            <div className="icon">
                                <img src={Quote} alt="quote" />
                            </div>
                            <h3>{testimonial.Des}</h3>
                            <h4>{testimonial.Title}</h4>
                            <span>{testimonial.Sub}</span>
                        </div>
                    </div>
                ))}

            </Slider>
        </section>
    );
}

export default Testimonial;







